<template>
  <v-dialog v-model="active" width="600">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-title style="white-space:normal">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ item.title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-html="item.dialogText" style="margin-top:2em"></v-card-text>
      <v-card-actions>
        <v-btn :href="item.link" color="success" target="_blank">Take test now</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="info" @click="dismiss()">Already Taken</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="dismiss()">Not Taking</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed, ref } from '@vue/composition-api'
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          title: '',
          link: '',
          dialogText: '',
          added: new Date(),
          viewed: null,
          clicked: null,
          done: false,
          dismissed: false
        }
      }
    }
  },
  setup (props, { root }) {
    const active = ref(false)
    const isSmall = computed(() => root.$vuetify.breakpoint.name === 'xs' || root.$vuetify.breakpoint.name === 'sm')

    async function dismiss () {
      // Find the item that matches the title
      const { _id, actions } = await root.$store.dispatch('getTracker')
      for (let i = 0; i < actions.length; i++) {
        if (actions[i].title === props.item.title) {
          root.$feathers.service('orientation/tracker').patch(_id, { ['actions.' + i + '.dismissed']: true }).then(({ actions }) => {
            active.value = false
            root.$store.commit('setActions', actions)
          })
          break
        }
      }
    }

    return {
      active,
      isSmall,
      dismiss
    }
  }
}
</script>
